import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { WHY_CHOOSE } from "@/data/content";

export default function WhyChoose() {
  return (
    <section
      id="why"
      data-testid="why-choose"
      className="py-20 md:py-28 border-y border-gray-200/70"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <span className="text-[11px] uppercase tracking-[0.18em] font-bold text-gray-500">
              Why Money Mart
            </span>
            <h2 className="mt-2 text-3xl sm:text-4xl font-bold font-heading tracking-tight text-[#0F2D52] leading-tight">
              Advisory-led loan facilitation — designed around your profile.
            </h2>
            <p className="mt-4 text-base text-gray-600 leading-relaxed">
              We combine banking expertise, transparent process, and dedicated relationship managers to help you navigate multiple lender options with clarity.
            </p>
          </div>
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {WHY_CHOOSE.map((w, i) => {
              const Icon = Icons[w.icon] || Icons.Shield;
              return (
                <motion.div
                  key={w.title}
                  initial={{ opacity: 0, y: 12 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.45, delay: i * 0.05 }}
                  data-testid={`why-card-${i}`}
                  className="rounded-2xl bg-white border border-gray-200 p-5 hover:shadow-[0_12px_30px_rgba(15,45,82,0.06)] mm-transition"
                >
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-xl bg-[#D4AF37]/10 flex items-center justify-center shrink-0">
                      <Icon className="h-5 w-5 text-[#0F2D52]" strokeWidth={1.6} />
                    </div>
                    <div>
                      <h3 className="text-base font-bold text-[#0F2D52] font-heading tracking-tight">
                        {w.title}
                      </h3>
                      <p className="mt-1 text-sm text-gray-600 leading-relaxed">
                        {w.desc}
                      </p>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
